import { styled, useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import DownloadIcon from '../../shared/DownloadIcon';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import SplitButton from '../../shared/SplitButton';
import DropDownMenu from '../../../components/shared/DropDownMenu';
import TrashIcon from '../../shared/TrashIcon';

const WhiteBorderTextField = styled(TextField)`

    justify-content: center;

    & :focus:not(:hover) {
        border-color: transparent;
        outline: 0px solid transparent;
    }

    &:not(:focus){
        border-color: transparent;
        outline: 0px solid transparent;
    }
    & :focus:not(:active){
        border-color: transparent;
        outline: 0px solid transparent;
    }
      
    & :focus-visible {
        border-color: transparent;
        outline: 0px solid transparent;
    }

    .MuiOutlinedInput-root {
            padding-right: 4px;
            
            & :focus {
                border-color: transparent;
                outline: 0px solid transparent;
            }

            &:hover fieldset{
                border-color: transparent;
                outline: 0px solid transparent;
            }
            & :focus:not(:hover) fieldset {
                border-color: transparent;
                outline: 0px solid transparent;
           }

           &:not(:focus) fieldset {
            border-color: transparent;
            outline: 0px solid transparent;
        }
            & :focus:not(:active)  fieldset{
                border-color: transparent;
                outline: 0px solid transparent;
            }
    }
    
    fieldset .Mui-focused {
        &.MuiOutlinedInput-notchedOutline {
            border-color: transparent;
        }
    }

  .MuiOutlinedInput-notchedOutline {
    border-color: transparent;

    &:hover {
        border-color: transparent;
    }
    & :focus {
        border-color: transparent;
        outline: 0px solid transparent;
    }
    & :focus:not(:hover) {
        border-color: transparent;
        outline: 0px solid transparent;
      }
  }

    .Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: transparent;
     }

    & .MuiOutlinedInput {
      border-color: transparent;


    &.Mui-focused  {
      border-color: transparent;

        &.MuiOutlinedInput-notchedOutline {
            border-color: transparent;

        }
    }
  }
  
`;


export default function EnrollmentListTopTools( { openAddEnrollment } : { openAddEnrollment: () => void}) {
    const theme = useTheme();
    
    return (
        <Grid item={true} xs={12} >
            <Stack sx={{ position: "relative", justifyContent: 'space-between' }} direction="row" spacing={0}>
                <Stack direction="row" spacing={2} >
                    <WhiteBorderTextField
                        size="small"
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 2,
                            boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                        }}
                        placeholder='Search Enrollments'
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="secondary"
                                        fontSize='large'
                                    />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <Button variant="contained" size="large" color="secondary" sx={{ height: '100%', borderRadius: 2, width: '40%'}}>Search</Button>
                            ),
                        }}
                    />

                    <SplitButton options={['Sort By', 'Name']} />
                </Stack>

                <Stack direction="row" spacing={2} sx={{ mr: 2 }}>
                    <IconButton color="secondary" aria-label="delete" component="span" 
                        sx={{ border: 0, 
                            boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                            borderRadius: 2, 
                            backgroundColor: 'white',  
                            pl: 1, pr: 1 }}>
                       <TrashIcon viewBox="0 0 46 46" />
                    </IconButton>

                    {/* <Button 
                        onClick={openAddEnrollment}
                        startIcon={<AddIcon fontSize="small" />} color="secondary" size="large"
                        sx={{ border: 0, 
                            boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                            borderRadius: 2, 
                            backgroundColor: 'white', 
                            fontWeight: 'bold', 
                            color: 'secondary.main', 
                            fontSize: '15px' }}>
                            Enroll New Person
                    </Button> 
                     */}

                    <DropDownMenu   />

                    <Button color="secondary" sx={{ 
                        boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                        border: 0, 
                        borderRadius: 2, 
                        backgroundColor: 'white', 
                        fontWeight: 'bold', 
                        fontSize: '14px',
                        color: 'secondary.main' }}
                        size="large"
                        endIcon={<DownloadIcon viewBox="0 0 42 37" sx={{ mt: '4px' }} />}
                    >Download</Button>

                </Stack>

            </Stack>


        </Grid>

    )
}
